const axios = require("axios").default;

const URL_MATERIAL = `${process.env.REACT_APP_API_URL}/materialbatch`;
const URL_PARAM = `${process.env.REACT_APP_API_URL}/param`;
const URL_CUSTOMER = `${process.env.REACT_APP_API_URL}/customer`;
const URL_RETURN = `${process.env.REACT_APP_API_URL}/return`;

export const getMaterial = (payload) => {
  return axios.get(URL_MATERIAL, {
    params: payload,
  });
};

export const getParam = (payload) => {
  return axios.get(URL_PARAM, {
    params: payload,
  });
};

export const getCustomer = (payload) => {
  return axios.get(URL_CUSTOMER, {
    params: payload,
  });
};

export const postApproval = (payload) => {
  return axios.post(URL_RETURN, payload);
};

// export const postAttch = (retNumber) => {
//   return axios.post(`${URL_RETURN}/attachment`);
// };

export const postFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${URL_RETURN}/attachment`, formData);
};

export const getFile = (fileID = null) => {
  return axios.get(`${URL_RETURN}/attachment/${fileID}`);
};

export const updateDraft = (payload, id) => {
  return axios.put(`${URL_RETURN}/${id}`, payload);
};
